import axios from 'axios';

const FAKE_RESPONSE = [
  {
    postcode: 'B3 1PX',
    postcode_inward: '1PX',
    postcode_outward: 'B3',
    post_town: 'Birmingham',
    dependant_locality: '',
    double_dependant_locality: '',
    thoroughfare: 'Charlotte Street',
    dependant_thoroughfare: '',
    building_number: '52',
    building_name: '',
    sub_building_name: '',
    po_box: '',
    department_name: '',
    organisation_name: 'The Challenge Network',
    udprn: 331834,
    postcode_type: 'S',
    su_organisation_indicator: 'Y',
    delivery_point_suffix: '1L',
    line_1: 'The Challenge Network',
    line_2: '52 Charlotte Street',
    line_3: '',
    premise: '52',
    longitude: -1.9069446,
    latitude: 52.4843007,
    eastings: 406416,
    northings: 287378,
    country: 'England',
    traditional_county: 'Warwickshire',
    administrative_county: '',
    postal_county: 'West Midlands',
    county: 'West Midlands',
    district: 'Birmingham',
    ward: 'Soho & Jewellery Quarter',
    uprn: '100071384017',
    id: 'paf_331834',
    country_iso: 'GBR',
    country_iso_2: 'GB',
    county_code: '',
    language: 'en',
    umprn: '',
    dataset: 'paf',
  },
  {
    postcode: 'B3 1PX',
    postcode_inward: '1PX',
    postcode_outward: 'B3',
    post_town: 'Birmingham',
    dependant_locality: '',
    double_dependant_locality: '',
    thoroughfare: 'Charlotte Street',
    dependant_thoroughfare: '',
    building_number: '55',
    building_name: '',
    sub_building_name: '',
    po_box: '',
    department_name: '',
    organisation_name: 'Baily Garner',
    udprn: 331835,
    postcode_type: 'S',
    su_organisation_indicator: 'Y',
    delivery_point_suffix: '1E',
    line_1: 'Baily Garner',
    line_2: '55 Charlotte Street',
    line_3: '',
    premise: '55',
    longitude: -1.9063999,
    latitude: 52.4842373,
    eastings: 406453,
    northings: 287371,
    country: 'England',
    traditional_county: 'Warwickshire',
    administrative_county: '',
    postal_county: 'West Midlands',
    county: 'West Midlands',
    district: 'Birmingham',
    ward: 'Soho & Jewellery Quarter',
    uprn: '100071384018',
    id: 'paf_331835',
    country_iso: 'GBR',
    country_iso_2: 'GB',
    county_code: '',
    language: 'en',
    umprn: '',
    dataset: 'paf',
  },
  {
    postcode: 'B3 1PX',
    postcode_inward: '1PX',
    postcode_outward: 'B3',
    post_town: 'Birmingham',
    dependant_locality: '',
    double_dependant_locality: '',
    thoroughfare: 'Charlotte Street',
    dependant_thoroughfare: '',
    building_number: '59',
    building_name: '',
    sub_building_name: '',
    po_box: '',
    department_name: '',
    organisation_name: '',
    udprn: 331838,
    postcode_type: 'S',
    su_organisation_indicator: '',
    delivery_point_suffix: '1B',
    line_1: '59 Charlotte Street',
    line_2: '',
    line_3: '',
    premise: '59',
    longitude: -1.9064,
    latitude: 52.484237,
    eastings: 406453,
    northings: 287371,
    country: 'England',
    traditional_county: 'Warwickshire',
    administrative_county: '',
    postal_county: 'West Midlands',
    county: 'West Midlands',
    district: 'Birmingham',
    ward: 'Soho & Jewellery Quarter',
    uprn: '',
    id: 'paf_331838',
    country_iso: 'GBR',
    country_iso_2: 'GB',
    county_code: '',
    language: 'en',
    umprn: '',
    dataset: 'paf',
  },
  {
    postcode: 'B3 1PX',
    postcode_inward: '1PX',
    postcode_outward: 'B3',
    post_town: 'Birmingham',
    dependant_locality: '',
    double_dependant_locality: '',
    thoroughfare: 'Charlotte Street',
    dependant_thoroughfare: '',
    building_number: '61',
    building_name: '',
    sub_building_name: '',
    po_box: '',
    department_name: '',
    organisation_name: 'J E Johnson Ltd',
    udprn: 54584819,
    postcode_type: 'S',
    su_organisation_indicator: 'Y',
    delivery_point_suffix: '1N',
    line_1: 'J E Johnson Ltd',
    line_2: '61 Charlotte Street',
    line_3: '',
    premise: '61',
    longitude: -1.9060314,
    latitude: 52.4844078,
    eastings: 406478,
    northings: 287390,
    country: 'England',
    traditional_county: 'Warwickshire',
    administrative_county: '',
    postal_county: 'West Midlands',
    county: 'West Midlands',
    district: 'Birmingham',
    ward: 'Soho & Jewellery Quarter',
    uprn: '100071384019',
    id: 'paf_54584819',
    country_iso: 'GBR',
    country_iso_2: 'GB',
    county_code: '',
    language: 'en',
    umprn: '',
    dataset: 'paf',
  },
  {
    postcode: 'B3 1PX',
    postcode_inward: '1PX',
    postcode_outward: 'B3',
    post_town: 'Birmingham',
    dependant_locality: '',
    double_dependant_locality: '',
    thoroughfare: 'Charlotte Street',
    dependant_thoroughfare: '',
    building_number: '61',
    building_name: '',
    sub_building_name: '',
    po_box: '',
    department_name: '',
    organisation_name: 'Michael Dufty Partnership',
    udprn: 331837,
    postcode_type: 'S',
    su_organisation_indicator: 'Y',
    delivery_point_suffix: '1A',
    line_1: 'Michael Dufty Partnership',
    line_2: '61 Charlotte Street',
    line_3: '',
    premise: '61',
    longitude: -1.9064,
    latitude: 52.484237,
    eastings: 406453,
    northings: 287371,
    country: 'England',
    traditional_county: 'Warwickshire',
    administrative_county: '',
    postal_county: 'West Midlands',
    county: 'West Midlands',
    district: 'Birmingham',
    ward: 'Soho & Jewellery Quarter',
    uprn: '',
    id: 'paf_331837',
    country_iso: 'GBR',
    country_iso_2: 'GB',
    county_code: '',
    language: 'en',
    umprn: '',
    dataset: 'paf',
  },
];

export const AddressLookupApi = {
  autocomplete: (text, onSuccess, onError) => {
    const formData = new FormData();
    const config = {};
    axios
      .get(
        `https://api.ideal-postcodes.co.uk/v1/autocomplete/addresses?api_key=iddqd&q=${text}`,
        formData,
        config,
      )
      .then(response => {
        onSuccess(response.data);
      })
      .catch(onError);
  },
  addressByPostcode: (postcode, onSuccess, onError) => {
    axios
      .get(
        `https://api.ideal-postcodes.co.uk/v1/postcodes/${postcode}?api_key=ak_lgl0wkv0FQr8Mx40GMZGGoDV8QXAy`,
      )
      .then(response => {
        onSuccess(response.data.result);
        // console.log(response.data.result);
      })
      .catch(e => {
        onError(e);
        // console.log(e);
        // if (Math.floor(Math.random() * 2) === 0) {
        //   onSuccess(FAKE_RESPONSE);
        // } else {
        //   onError(e);
        // }
      });
  },
};

export default AddressLookupApi;



// WEBPACK FOOTER //
// ./app/javascript/design/api/address-lookup-api.js